// extracted by mini-css-extract-plugin
export default {"multi":"Multi_multi__tIXI5","row":"Multi_row__JsPZf","item":"Multi_item__VvY8h","label":"Multi_label__hcRIk","checkbox":"Multi_checkbox__lQ3Nr","error":"Multi_error__Yy0nm"};